import label from "@/lang/StaticLabels.js";

// PMRPAL Router  - برنامه ریزی تولید آلومینیوم -----------------------------------------------
let routeItems = {
  path: "PMRPAL",
  name: "PMRPAL",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PMRPALDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PMRPALDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pmrpAl,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/Dashboard"),
    },

    // Base Information -----------------------------------------------
    {
      path: "workStation",
      name: "PMRPALWorkStation",
      meta: {
        label: label.page.workStations,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/workStation"),
    },
    {
      path: "workShift",
      name: "PMRPALWorkShift",
      meta: {
        label: label.page.workShifts,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/workShift"),
    },
    {
      path: "bom",
      name: "PMRPALBOM",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/bom/list",
      children: [
        {
          path: "list",
          name: "PMRPALBOMList",
          component: () => import("@/views/modules/pmrpAl/base/bom"),
          meta: {
            label: label.page.bom,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PMRPALAddBOM",
          meta: {
            label: label.page.addBom,
            requiresAuth: true,
          },
          component: () => import("@/views/modules/pmrpAl/base/bom/Info"),
        },

        {
          path: "edit/:id",
          name: "PMRPALEditBOM",
          component: () => import("@/views/modules/pmrpAl/base/bom/Info"),
          meta: {
            label: label.page.editBom,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "sprint",
      name: "PMRPALSprint",
      meta: {
        label: label.page.sprint,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/sprint"),
    },
    {
      path: "processType",
      name: "PMRPALProcessType",
      meta: {
        label: label.page.processType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/processType"),
    },
    {
      path: "hardness",
      name: "PMRPALHardness",
      meta: {
        label: label.page.hardness,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/hardness"),
    },
    {
      path: "productSurface",
      name: "PMRPALProductSurface",
      meta: {
        label: label.page.productSurface,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/productSurface"),
    },
    {
      path: "usageGroup",
      name: "PMRPALUsageGroup",
      meta: {
        label: label.page.usageGroup,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/usageGroup"),
    },
    {
      path: "foilUsage",
      name: "PMRPALFoilUsage",
      meta: {
        label: label.page.foilUsage,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/foilUsage"),
    },
    {
      path: "innerCoreDiameter",
      name: "PMRPALInnerCoreDiameter",
      meta: {
        label: label.page.innerCoreDiameter,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/innerCoreDiameter"),
    },
    {
      path: "furnace",
      name: "PMRPALFurnace",
      meta: {
        label: label.page.furnace,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/furnace"),
    },
    {
      path: "systemSetting",
      name: "PMRPALSystemSetting",
      meta: {
        label: label.page.settings,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpAl/base/systemSetting"),
    },

    // Operation -----------------------------------------------
    {
      path: "order",
      name: "PMRPALOrder",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/order/list",
      children: [
        {
          path: "list",
          name: "PMRPALOrderList",
          component: () => import("@/views/modules/pmrpAl/operation/order"),
          meta: {
            label: label.page.order,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PMRPALAddOrder",
          meta: {
            label: label.page.addOrder,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pmrpAl/operation/order/Info"),
        },
        {
          path: "edit/:id",
          name: "PMRPALEditOrder",
          component: () =>
            import("@/views/modules/pmrpAl/operation/order/Info"),
          meta: {
            label: label.page.editOrder,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "cartable",
      name: "PMRPALCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "cartable/casting",
      children: [
        {
          path: "casting",
          name: "PMRPALCastingCartable",
          component: () =>
            import("@/views/modules/pmrpAl/operation/cartable/Casting"),
          meta: {
            label: label.page.castingCartable,
            requiresAuth: true,
          },
        },
        {
          path: "coldRolling",
          name: "PMRPALColdRollingCartable",
          component: () =>
            import("@/views/modules/pmrpAl/operation/cartable/ColdRolling"),
          meta: {
            label: label.page.coldRollingtCartable,
            requiresAuth: true,
          },
        },
        {
          path: "foilRolling",
          name: "PMRPALFoilRollingCartable",
          component: () =>
            import("@/views/modules/pmrpAl/operation/cartable/FoilRolling"),
          meta: {
            label: label.page.foilRollingCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "managementCartable",
      name: "PMRPALManagementCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "managementCartable/casting",
      children: [
        {
          path: "casting",
          name: "PMRPALCastingManagementCartable",
          component: () =>
            import(
              "@/views/modules/pmrpAl/operation/managementCartable/Casting"
            ),
          meta: {
            label: label.page.castingManagementCartable,
            requiresAuth: true,
          },
        },
        {
          path: "coldRolling",
          name: "PMRPALColdRollingManagementCartable",
          component: () =>
            import(
              "@/views/modules/pmrpAl/operation/managementCartable/ColdRolling"
            ),
          meta: {
            label: label.page.coldRollingManagementCartable,
            requiresAuth: true,
          },
        },
        {
          path: "foilRolling",
          name: "PMRPALFoilRollingManagementCartable",
          component: () =>
            import(
              "@/views/modules/pmrpAl/operation/managementCartable/FoilRolling"
            ),
          meta: {
            label: label.page.foilRollingManagementCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "produceOrder",
      name: "PMRPALProduceOrder",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/produceOrder/list",
      children: [
        {
          path: "list",
          name: "PMRPALProduceOrderList",
          component: () =>
            import("@/views/modules/pmrpAl/operation/produceOrder"),
          meta: {
            label: label.page.produceOrder,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PMRPALAddProduceOrder",
          meta: {
            label: label.page.addProduceOrder,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pmrpAl/operation/produceOrder/Add"),
        },
      ],
    },
    {
      path: "casting",
      name: "PMRPALCasting",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/casting/list",
      children: [
        {
          path: "list",
          name: "PMRPALCastingList",
          component: () => import("@/views/modules/pmrpAl/operation/casting"),
          meta: {
            label: label.page.casting,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "castingQC",
      name: "PMRPALCastingQC",
      component: () => import("@/views/modules/pmrpAl/operation/castingQC"),
      meta: {
        label: label.page.castingQC,
        requiresAuth: true,
      },
    },
    {
      path: "coldRolling",
      name: "PMRPALColdRolling",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/coldRolling/list",
      children: [
        {
          path: "list",
          name: "PMRPALColdRollingList",
          component: () =>
            import("@/views/modules/pmrpAl/operation/coldRolling"),
          meta: {
            label: label.page.coldRolling,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "coldRollingQC",
      name: "PMRPALColdRollingQC",
      component: () => import("@/views/modules/pmrpAl/operation/coldRollingQC"),
      meta: {
        label: label.page.coldRollingQC,
        requiresAuth: true,
      },
    },
    {
      path: "foilRolling",
      name: "PMRPALFoilRolling",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/foilRolling/list",
      children: [
        {
          path: "list",
          name: "PMRPALFoilRollingList",
          component: () =>
            import("@/views/modules/pmrpAl/operation/foilRolling"),
          meta: {
            label: label.page.foilRolling,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "foilRollingQC",
      name: "PMRPALFoilRollingQC",
      component: () => import("@/views/modules/pmrpAl/operation/foilRollingQC"),
      meta: {
        label: label.page.foilRollingQC,
        requiresAuth: true,
      },
    },
    //  Reports -----------------------------------------------
    {
      path: "productionReports",
      name: "PMRPALproductionReports",
      component: () =>
        import("@/views/modules/pmrpAl/reports/productionReport"),
      meta: {
        label: label.page.productionReports,
        requiresAuth: true,
      },
    },
    {
      path: "produceOrderReports",
      name: "PMRPALProduceOrderReports",
      component: () => import("@/views/modules/pmrpAl/reports/produceOrders"),
      meta: {
        label: label.page.produceOrder,
        requiresAuth: true,
      },
    },
    {
      path: "castingReport",
      name: "PMRPALCastingReport",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/castingReport/list",
      children: [
        {
          path: "list",
          name: "PMRPALCastingReportList",
          component: () => import("@/views/modules/pmrpAl/reports/casting"),
          meta: {
            label: label.page.castingReport,
            requiresAuth: true,
          },
        },
        {
          path: "add/:produceOrderId?",
          name: "PMRPALAddCastingReport",
          meta: {
            label: label.page.addCastingReport,
            requiresAuth: true,
          },
          component: () => import("@/views/modules/pmrpAl/reports/casting/Add"),
        },
      ],
    },
    {
      path: "coldRollingReport",
      name: "PMRPALColdRollingReport",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/coldRollingReport/list",
      children: [
        {
          path: "list",
          name: "PMRPALColdRollingReportList",
          component: () => import("@/views/modules/pmrpAl/reports/coldRolling"),
          meta: {
            label: label.page.coldRollingReport,
            requiresAuth: true,
          },
        },
        {
          path: "add/:produceOrderId?",
          name: "PMRPALAddColdRollingReport",
          meta: {
            label: label.page.addColdRollingReport,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pmrpAl/reports/coldRolling/Add"),
        },
      ],
    },
    {
      path: "foilRollingReport",
      name: "PMRPALFoilRollingReport",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/foilRollingReport/list",
      children: [
        {
          path: "list",
          name: "PMRPALFoilRollingReportList",
          component: () => import("@/views/modules/pmrpAl/reports/foilRolling"),
          meta: {
            label: label.page.foilRollingReport,
            requiresAuth: true,
          },
        },
        {
          path: "add/:produceOrderId?",
          name: "PMRPALAddFoilRollingReport",
          meta: {
            label: label.page.addFoilRollingReport,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pmrpAl/reports/foilRolling/Add"),
        },
      ],
    },
  ],
};

export default routeItems;
